'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MatchMedia = require('./MatchMedia');

var _MatchMedia2 = _interopRequireDefault(_MatchMedia);

var _breakpoints = require('../constants/breakpoints');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Large = function Large(_ref) {
  var children = _ref.children,
      mediaFeatures = _ref.mediaFeatures;
  return _react2.default.createElement(
    _MatchMedia2.default,
    { mediaQuery: '(min-width: ' + _breakpoints.LARGE + 'px)', mediaFeatures: mediaFeatures },
    children
  );
};

Large.propTypes = {
  mediaFeatures: _propTypes2.default.shape({ width: _propTypes2.default.string })
};

Large.defaultProps = {
  mediaFeatures: null
};

exports.default = Large;


// WEBPACK FOOTER //
// ../~/@jg/components/es/Responsive/components/Large.js